import {eq} from '@shared/helpers/lang'
import {qs as queryString} from '@shared/helpers/queryString'

import {ARS_SERVICE_ID} from '@web/core/constants'

import {FDSAction, FDSActionType, FdsResult} from '../../constants'

/**
 * 비번인증창 URL 생성
 * TODO: passBioAuthUrl 내재화. 외부 리소스이고, 고정값
 * @returns {string} 비번 인증창 URL
 */
export function getPassBioAuthUrl({
    actionType,
    applyUrl,
    closeable = true,
    fdsAuthBridgeUrl,
    orderSheetUrl,
    passBioAuthUrl,
    sessionKey,
}: {
    /** 비번 인증 결과 수신용 브릿지의 동작 타입 */
    actionType: FDSActionType
    /** 비번인증 결과 수신 브릿지 페이지에 전달될 rurl 파라메터 */
    applyUrl: string
    /** 비번창 닫기 버튼 노출 여부 */
    closeable?: boolean
    /** 비번인증 결과를 수신할 브릿지 페이지 */
    fdsAuthBridgeUrl: string
    /** 비번인증 결과 수신 브릿지 페이지에 전달되는 surl 파라메터 */
    orderSheetUrl: string
    /** 비번 인증창 URL */
    passBioAuthUrl: string
    /** 비번인증창에 전달되는 세션 키 */
    sessionKey: string
}) {
    const fdsBridgeQuery = queryString.stringify({
        action: actionType,
        ...(actionType === 'REPLACE' ? {rurl: applyUrl, surl: orderSheetUrl} : {}),
    })

    const successBridgeUrl = `${fdsAuthBridgeUrl}/${FdsResult.KEYPAD_SUCCESS}?${fdsBridgeQuery}`
    const cancelBridgeUrl = `${fdsAuthBridgeUrl}/${FdsResult.KEYPAD_FAIL}?${fdsBridgeQuery}`
    const query = queryString.stringify({
        rurl: encodeURIComponent(successBridgeUrl),
        surl: encodeURIComponent(cancelBridgeUrl),
        sessionKey,
        ...(!closeable ? {hideButton: true} : {}),
    })
    return `${passBioAuthUrl}?${query}`
}

export function getARSUrl({
    arsUrl,
    fdsAuthBridgeUrl,
    fdsUuid,
    actionType,
    applyUrl,
    orderSheetUrl,
}: {
    /** ARS 인증창 url */
    arsUrl: string
    /** ARS 인증 결과를 수신할 브릿지 페이지 */
    fdsAuthBridgeUrl: string
    /** 페이 ARS 인증창에 전달할 FDS 인증 uuid */
    fdsUuid?: string
    /** ARS 인증 결과 수신용 브릿지의 동작 타입 */
    actionType: FDSActionType
    /** ARS 인증 결과 수신 브릿지 페이지에 전달될 rurl 파라메터 */
    applyUrl: string
    /** ARS 인증 결과 수신 브릿지 페이지에 전달되는 surl 파라메터 */
    orderSheetUrl: string
}) {
    const isPopup = eq(FDSAction.POPUP, actionType)
    const isReplace = eq(FDSAction.REPLACE, actionType)

    const fdsBridgeQuery = queryString.stringify({
        action: actionType,
        ...(isReplace ? {rurl: applyUrl, surl: orderSheetUrl} : {}),
    })
    const successBridgeUrl = `${fdsAuthBridgeUrl}/${FdsResult.ARS_SUCCESS}?${fdsBridgeQuery}`

    const query = queryString.stringify({
        serviceId: ARS_SERVICE_ID.ORDER_SHEET,
        rurl: successBridgeUrl,
        method: 'ars',
        fdsUuid,
        ...(isReplace ? {surl: orderSheetUrl} : {}),
        ...(isPopup ? {backButton: 'hide', backType: 'close'} : {}),
    })

    return `${arsUrl}?${query}`
}
